<div fxLayout="row" fxLayoutAlign="space-around center">
  <ng-container *ngIf="availabilities?.data && currentCartItemId && (availabilities?.data | cartCurrentListItemAvailablity : currentCartItemId)">
    <ng-container [ngSwitch]="true">
      <div
        class="cart-current-list-item-availability cart-current-list-item-availability--on-request"
        *ngSwitchCase="(availabilities?.data | cartCurrentListItemAvailablity : currentCartItemId)?.I18NCode.toLowerCase().includes('on request')">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>

      <div
        class="cart-current-list-item-availability cart-current-list-item-availability--on-stock-limited"
        *ngSwitchCase="(availabilities?.data | cartCurrentListItemAvailablity : currentCartItemId)?.I18NCode.includes('On stock (limited availability)')">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>

      <div
        class="cart-current-list-item-availability cart-current-list-item-availability--in-stock-limited"
        *ngSwitchCase="(availabilities?.data | cartCurrentListItemAvailablity : currentCartItemId)?.I18NCode.toLowerCase().includes('in stock (limited availability)')">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>

      <div
        class="cart-current-list-item-availability cart-current-list-item-availability--on-request"
        *ngSwitchCase="(availabilities?.data | cartCurrentListItemAvailablity : currentCartItemId)?.I18NCode.toLowerCase().includes('partially in stock')">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>

      <div class="cart-current-list-item-availability cart-current-list-item-availability--on-stock" *ngSwitchDefault>
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </ng-container>
  </ng-container>
  <spx-spinner *ngIf="!availabilities?.data && availabilities?.isPending" [size]="'INLINE'"></spx-spinner>
</div>

<ng-template #content>
  <span matTooltip="{{ (availabilities?.data | cartCurrentListItemAvailablity : currentCartItemId)?.I18NBodyCode | translate }}">
    {{ translateKey((availabilities?.data | cartCurrentListItemAvailablity : currentCartItemId)?.I18NCode) | translate }} <br />
  </span>
</ng-template>
